import "./App.css"
import Navbar from "./components/Navbar"
import Hero from "./components/Hero.js"
import New from "./components/New.js"
import Suggested from "./components/Suggested.js"

function App() {
  return (
    <div className='App'>
      <Navbar />
      <div className='showcase'>
        <Hero />
        <New />
      </div>
      <Suggested />
    </div>
  )
}

export default App
